import { gql } from "graphql-request";
import * as z from "zod";

import {
  EsportCarouselLiveEntry,
  EsportCarouselLiveEntryFragment,
} from "./esportCarouselLiveEntry";

import {
  EsportCarouselEventEntry,
  EsportCarouselEventEntryFragment,
} from "./esportCarouselEventEntry";

import { Sys, SysFragment } from "../sys";
import { Targeting, TargetingFragment } from "../targeting";
import { RelatedMedia, RelatedMediaFragment } from "../relatedMedia";

export const EsportCarouselEntry = z.object({
  sys: Sys,
  sortDate: z.string().nullable(),
  targeting: Targeting.nullish(),
  relatedMedia: RelatedMedia.nullish(),
  localized: z
    .discriminatedUnion("__typename", [
      EsportCarouselLiveEntry,
      EsportCarouselEventEntry,
    ])
    .nullish(),
});

export type EsportCarouselEntry = z.infer<typeof EsportCarouselEntry>;

export const EsportCarouselEntryFragment = gql`
  fragment EsportCarouselEntryFragment on EsportCarouselEntry {
    sys {
      ...SysFragment
    }
    sortDate
    targeting {
      ...TargetingFragment
    }
    relatedMedia {
      ...RelatedMediaFragment
    }
    localized {
      ... on EsportCarouselEventEntry {
        ...EsportCarouselEventEntryFragment
      }
      ... on EsportLiveEventEntry {
        ...EsportCarouselLiveEntryFragment
      }
    }
  }

  ${EsportCarouselLiveEntryFragment}
  ${EsportCarouselEventEntryFragment}
  ${SysFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
`;
